import { render, staticRenderFns } from "./lkuAdvertiser.vue?vue&type=template&id=3f8a240f"
import script from "./lkuAdvertiser.vue?vue&type=script&lang=js"
export * from "./lkuAdvertiser.vue?vue&type=script&lang=js"
import style0 from "./lkuAdvertiser.vue?vue&type=style&index=0&id=3f8a240f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports